import { createFileRoute } from '@tanstack/react-router'
import { ValueStoryDetails } from 'pages/valueStories/ValueStoryDetails'
import { valueStoryDetailsSearchParams } from 'routes/value-stories/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId, valueStoryId } = Route.useSearch()

  return (
    <ValueStoryDetails
      orgId={orgId}
      siteId={siteId}
      valueStoryId={valueStoryId}
    />
  )
}

export const Route = createFileRoute('/value-stories/details')({
  component: RouteComponent,
  staticData: {
    title: 'Value Story Details',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: valueStoryDetailsSearchParams,
})
